import searchLogo from "@assets/search.svg";

type SearchButtonProps = {
  /**
   * Callback triggered when the search button is clicked.
   */
  onClick: () => void;
};

/**
 * Renders a button with a search icon.
 *
 * @param props - Search button properties.
 * @returns The search button element.
 */
export function SearchButton({ onClick }: SearchButtonProps) {
  return (
    <>
      <button
        data-testid="searchButton"
        onClick={onClick}
        className="focus:shadow-5xl rounded pr-3 lg:pl-3 pb-1"
      >
        <img
          src={searchLogo}
          className="-rotate-90"
          alt="search-logo"
          width="30"
          height="30"
        />
      </button>
    </>
  );
}
